import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'supplierType',
  standalone: true
})
export class SupplierTypePipe implements PipeTransform {
  private typeMap: Record<string, string> = {
    'NEW_SUPPLIER': 'Новый поставщик',
    'HISTORICAL_SUPPLIER': 'Исторический поставщик'
  };

  transform(type: string): string {
    return this.typeMap[type] || type;
  }
}
